import React from "react";
import { OcRoleFilterSummaryItemView } from "./role-filter-summary-item-view";
import { useOcRoleFilterSummaryItem } from "./use-role-filter-summary-item";

export interface OcRoleFilterSummaryItemProps {
  label: string;
  value: string | number | undefined;
  color?: string;
}

export const OcRoleFilterSummaryItem: React.FC<
  OcRoleFilterSummaryItemProps
> = ({ label, value = 0, color }) => {
  const { translatedLabel, valueColor } = useOcRoleFilterSummaryItem({
    label,
    color,
  });

  return (
    <OcRoleFilterSummaryItemView
      color={valueColor}
      label={translatedLabel}
      value={value}
    />
  );
};
